import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Popup, Toast, Button } from 'antd-mobile'
import { saveRPE } from '../../../api/program'
import '../styles/EditRecommendationModal.css'
import '../styles/ProgramModal.css'
import '../styles/EditRecommendationModal.css'
import RPESelector from '../Charts/RPESelector'
import WeekDatePicker from '../Charts/WeekDatePicker'
import WorkoutListModal from './WorkoutListModal'
import ExerciseIcon from '../../../asserts/icons/physical-assessment/ExerciseIcon.svg'

function EditProgramModal({
  visible,
  onClose,
  onSave,
  onDelete,
  workoutDetail = {},
  readOnly,
  defaultSelectedDateIndex,
  onUpdated
}) {

  const secondsToMinutes = (seconds) => {
    const minutes = Math.floor((seconds || 0) / 60)
    return seconds % 60 < 30 ? minutes : minutes + 1
  }

  const [rpeValue, setRpeValue] = useState(1)
  const [selectedDateIndex, setSelectedDateIndex] = useState(
    moment().isoWeekday() - 1
  )

  const [workoutName, setWorkoutName] = useState(
    workoutDetail?.details?.activity_type_shown || ''
  )
  const [workoutDuration, setWorkoutDuration] = useState(() =>
    secondsToMinutes(workoutDetail?.details?.duration ?? 0).toString()
  )
  const durationInMinutes = secondsToMinutes(
    workoutDetail?.details?.duration
  )
  const trainingLoad = Math.round(rpeValue * durationInMinutes)
  const [workoutListModalVisible, setWorkoutListModalVisible] = useState(false)

  useEffect(() => {
    if (visible && workoutDetail?.details) {
      const details = workoutDetail.details

      setWorkoutName(details?.activity_type_shown || '')
      setWorkoutDuration(secondsToMinutes(details?.duration).toString())
      setRpeValue(workoutDetail?.rpe_manual ?? workoutDetail?.rpe_auto ?? 1)

      if (typeof defaultSelectedDateIndex === 'number') {
        setSelectedDateIndex(defaultSelectedDateIndex)
      }
    }
  }, [visible, workoutDetail])

  useEffect(() => {
    if (!visible) {
      setWorkoutName('')
      setWorkoutDuration('')
      setRpeValue(1)
      setSelectedDateIndex(moment().isoWeekday() - 1)
    }
  }, [visible])  

  const handleRPEChange = (val) => {
    setRpeValue(val)
  }

  const handleRPECommit = async (val) => {
    const workoutId = workoutDetail?.id
    if (!workoutId) return
    try {
      await saveRPE(workoutId, val)
      onUpdated?.()
    } catch (err) {
      console.error('Failed to save RPE:', err)
    }
  }

  const handleWorkoutTypeSelect = (selectedName, classification) => {
    setWorkoutName(selectedName)

    if (
      workoutDetail?.details?.activity_classification !== classification ||
      workoutDetail?.type !== classification
    ) {
      if (workoutDetail?.details) {
        workoutDetail.details.activity_classification = classification
      }
      workoutDetail.type = classification
    }

    setWorkoutListModalVisible(false)
  }

  return (
    <>
      <Popup
        visible={visible}
        onMaskClick={onClose}
        onClose={onClose}
        position="bottom"
        bodyClassName="modal-popup"
      >
        <div className="modal-content">
          <div className="modal-header-wrapper">
            <div className="modal-header">
              <h2>Edit Workout</h2>
              <button
                onClick={onClose}
                className="modal-close-btn"
                aria-label="Close"
              >
                Close
              </button>
            </div>
            <WeekDatePicker
              selectedDateIndex={selectedDateIndex}
              onSelectDate={(index) => setSelectedDateIndex(index)}
              readOnly={true}
            />
          </div>

          <div className="rpe-trend-container" style={{ paddingTop: '1px' }}>
            <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
              <img
                src={ExerciseIcon}
                alt="Exercise"
                style={{ marginTop: '10px' }}
              />

              <h4 className="heart-rate-trend-title">Workout Detail</h4>
            </div>
            <div style={{ marginBottom: '30px' }}>
              <label className="modal-label">Workout Name</label>

              <input
                id="workout-name"
                type="text"
                readOnly
                onClick={() => setWorkoutListModalVisible(true)}
                className="modal-select-box"
                value={workoutName}
                style={{
                  outline: 'none',
                  width: '100%',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            <div style={{ marginBottom: '30px' }}>
              <label className="modal-label">Workout Duration</label>
              <input
                id="workout-duration"
                className="modal-select-box"
                value={workoutDuration}
                onChange={(e) => setWorkoutDuration(e.target.value)}
                style={{
                  outline: 'none',
                  width: '100%',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <RPESelector
              rpeValue={rpeValue}
              onChange={handleRPEChange}
              onCommit={handleRPECommit}
              trainingLoad={trainingLoad}
            />
          </div>
          {!readOnly && (
            <div className="modal-button-group">
              <Button
                className="delete-button"
                onClick={() => onDelete?.(workoutDetail)}
              >
                Delete
              </Button>
              <Button
                className="save-button"
                onClick={() =>
                  onSave?.({
                    ...workoutDetail,
                    rpe_manual: rpeValue,
                    activity_type_shown: workoutName,
                    duration: workoutDuration,
                    type:
                      workoutDetail?.details?.activity_classification ||
                      workoutDetail?.type
                  })
                }
              >
                Save
              </Button>
            </div>
          )}
        </div>
      </Popup>

      <WorkoutListModal
        visible={workoutListModalVisible}
        onClose={() => setWorkoutListModalVisible(false)}
        onSelect={handleWorkoutTypeSelect}
      />
    </>
  )
}

export default EditProgramModal
